import { useState, useEffect } from 'react';
import { getImpostazioniPrezzi } from '../services/api';

// Stesso arrotondamento psicologico dell'equivalente backend (arrotonda_a_novanta).
export const arrotondaANovanta = (prezzo) => {
  if (!prezzo || prezzo <= 0) return prezzo;
  return Math.round((Math.floor(prezzo - 0.5) + 0.9) * 100) / 100;
};

export const calcolaPrezzoIbs = (prezzoFinale, percentualeIbs, markupFissoIbs) => {
  if (!prezzoFinale) return null;
  return arrotondaANovanta(prezzoFinale * (1 + (parseFloat(percentualeIbs) || 0) / 100) + (parseFloat(markupFissoIbs) || 0));
};

// Ricarico IBS configurato in "Ricarichi IBS" (percentuale + fisso), caricato una volta per form.
export const useImpostazioniPrezzi = () => {
  const [percentualeIbs, setPercentualeIbs] = useState(0);
  const [markupFissoIbs, setMarkupFissoIbs] = useState(0);
  useEffect(() => {
    getImpostazioniPrezzi()
      .then(res => {
        setPercentualeIbs(res.data.ibs_markup_percentuale || 0);
        setMarkupFissoIbs(res.data.ibs_markup_fisso || 0);
      })
      .catch(() => {});
  }, []);
  return { percentualeIbs, markupFissoIbs };
};
